/**
 * Contato guiado Titolin — uma pergunta por vez
 * Persiste em sessionStorage; submit nativo {% form 'contact' %}
 */
(function () {
  var STORAGE_KEY = 'tt-contato-state';
  var AUTO_MS = 200;
  var TRANSITION_MS = 260;

  var LABELS = {
    pedido: 'Ajuda com pedido',
    produto: 'Dúvida sobre brinquedo',
    escolher: 'Ajuda para escolher',
    troca: 'Troca ou devolução',
    pagamento: 'Ajuda com pagamento',
    entrega: 'Dúvida sobre entrega',
    outro: 'Outro assunto',
  };

  var state = {
    stepId: 'intro',
    history: [],
    direction: 'forward',
    answers: {
      categoria: '',
      categoriaLabel: '',
      motivo: '',
      motivoLabel: '',
      pedido: '',
      produto: '',
      produtoHandle: '',
      produtoImage: '',
      paraQuem: '',
      idade: '',
      objetivo: '',
      nome: '',
      email: '',
      telefone: '',
      mensagem_adicional: '',
      tone: 'discovery',
      skipPhone: false,
      confirmedName: false,
      confirmedEmail: false,
      confirmedPhone: false,
    },
  };

  var boot = null;
  var root = null;
  var stage = null;
  var formEl = null;
  var submitting = false;
  var searchTimer = null;

  function $(sel, el) {
    return (el || root).querySelector(sel);
  }

  function reduceMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function maskEmail(email) {
    if (!email || email.indexOf('@') < 0) return email || '';
    var parts = email.split('@');
    var local = parts[0];
    var show = local.slice(0, Math.min(2, local.length));
    return show + '••••@' + parts[1];
  }

  function maskPhone(phone) {
    if (!phone) return '';
    var digits = String(phone).replace(/\D/g, '');
    if (digits.length < 4) return '••••';
    return '(**) *****-' + digits.slice(-4);
  }

  /* Máscara BR: (00) 0000-0000 ou (00) 00000-0000 */
  function formatBrazilPhone(value) {
    var d = String(value || '').replace(/\D/g, '').slice(0, 11);
    if (!d.length) return '';
    if (d.length <= 2) return '(' + d;
    var out = '(' + d.slice(0, 2) + ') ';
    if (d.length <= 6) return out + d.slice(2);
    if (d.length <= 10) return out + d.slice(2, 6) + '-' + d.slice(6);
    return out + d.slice(2, 7) + '-' + d.slice(7, 11);
  }

  var PASTELS = [
    { bg: '#FFF1E4', accent: '#F4A243' },
    { bg: '#E7F3FB', accent: '#5FA8D3' },
    { bg: '#E7F7EE', accent: '#7DA870' },
    { bg: '#FCE8F1', accent: '#F6A6D2' },
    { bg: '#EEE8FA', accent: '#8B7EC8' },
    { bg: '#E4F6F7', accent: '#5BB8C4' },
    { bg: '#FFF7E0', accent: '#F4A243' },
  ];

  var ICON_PATHS = {
    package:
      '<path d="M12 3l8 4.5v9L12 21l-8-4.5v-9L12 3z"/><path d="M12 12l8-4.5M12 12v9M12 12L4 7.5"/>',
    toy:
      '<circle cx="12" cy="10" r="5"/><path d="M8 16c1.2 2 2.8 3 4 3s2.8-1 4-3"/><path d="M10 9h.01M14 9h.01"/>',
    sparkles:
      '<path d="M12 3.5l2.2 4.5 5 .7-3.6 3.5.85 5L12 15.2 7.55 17.2l.85-5L4.8 8.7l5-.7L12 3.5z"/>',
    return:
      '<path d="M9 7H5v4"/><path d="M5 11a7 7 0 107-7"/>',
    card:
      '<rect x="3" y="6" width="18" height="12" rx="2"/><path d="M3 10h18M7 14h4"/>',
    truck:
      '<path d="M3 7h11v10H3V7zM14 10h4l3 3v4h-7v-7z"/><circle cx="7" cy="18" r="1.5"/><circle cx="17" cy="18" r="1.5"/>',
    chat:
      '<path d="M5 6h14a2 2 0 012 2v6a2 2 0 01-2 2H9l-4 3v-3H5a2 2 0 01-2-2V8a2 2 0 012-2z"/>',
    gift:
      '<rect x="4" y="10" width="16" height="10" rx="1.5"/><path d="M12 10v10M4 14h16M12 10c-2-3-5-3-5 0 0 2 2.5 2 5 0zm0 0c2-3 5-3 5 0 0 2-2.5 2-5 0z"/>',
    brain:
      '<path d="M9.5 5.5a2.5 2.5 0 00-2.5 2.5v1A2 2 0 005.5 11v1.5A2 2 0 007 14.5v1a2.5 2.5 0 002.5 2.5h.5M14.5 5.5a2.5 2.5 0 012.5 2.5v1a2 2 0 011.5 2V12.5a2 2 0 01-1.5 2v1a2.5 2.5 0 01-2.5 2.5h-.5M12 5.5v13"/>',
    hand:
      '<path d="M8 11V7a1.5 1.5 0 013 0v4M11 10V6a1.5 1.5 0 013 0v5M14 10.5V7.5a1.5 1.5 0 013 0V14a5 5 0 01-5 5H11a5 5 0 01-5-5v-3a1.5 1.5 0 013 0v2"/>',
    search:
      '<circle cx="11" cy="11" r="6.25"/><path d="M16 16l4.5 4.5"/>',
    puzzle:
      '<path d="M10 4h4v3a1.5 1.5 0 003 0V4h1a2 2 0 012 2v3h-3a1.5 1.5 0 000 3h3v3a2 2 0 01-2 2h-1v-3a1.5 1.5 0 00-3 0v3h-4v-3a1.5 1.5 0 00-3 0v3H5a2 2 0 01-2-2v-3h3a1.5 1.5 0 000-3H3V6a2 2 0 012-2h1v3a1.5 1.5 0 003 0V4z"/>',
    heart:
      '<path d="M12 20s-6.5-4.2-8.5-8.2C2.2 8.8 3.6 5.5 6.8 5.5c1.8 0 3.2 1 4.2 2.4 1-1.4 2.4-2.4 4.2-2.4 3.2 0 4.6 3.3 3.3 6.3C18.5 15.8 12 20 12 20z"/>',
    shield:
      '<path d="M12 3l8 3.5v5.5c0 4.5-3.2 7.8-8 9.5-4.8-1.7-8-5-8-9.5V6.5L12 3z"/>',
    check:
      '<path d="M5 12.5l4.5 4.5L19 7"/>',
  };

  /* Ícone no mesmo slot dos cards de intent */
  function cardIcon(key) {
    var body = ICON_PATHS[key];
    if (!body) return '<span class="tt-contato__card-icon" aria-hidden="true"></span>';
    return (
      '<span class="tt-contato__card-icon tt-contato__card-icon--svg" aria-hidden="true">' +
      '<svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">' +
      body +
      '</svg></span>'
    );
  }

  function cardGo() {
    return (
      '<span class="tt-contato__card-go" aria-hidden="true">' +
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '</span>'
    );
  }

  /* Cabeçalho unificado (igual ao intent) */
  function panelTop(cfg) {
    cfg = cfg || {};
    return (
      '<div class="tt-contato__panel-top">' +
      (cfg.kicker
        ? '<p class="tt-contato__kicker">' + escapeHtml(cfg.kicker) + '</p>'
        : '') +
      '<h2 class="tt-contato__title tt-contato__title--intent">' +
      cfg.title +
      '</h2>' +
      (cfg.lead
        ? '<p class="tt-contato__lead tt-contato__lead--intent">' + cfg.lead + '</p>'
        : '') +
      '</div>'
    );
  }

  function panelWrap(topCfg, bodyHtml, screenClass) {
    return wrapScreen(
      '<div class="tt-contato__panel">' +
        panelTop(topCfg) +
        bodyHtml +
        '</div>',
      { screenClass: screenClass || 'tt-contato__screen--flow' }
    );
  }

  function saveState() {
    try {
      sessionStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ stepId: state.stepId, history: state.history, answers: state.answers })
      );
    } catch (e) {
      /* ignore */
    }
  }

  function loadState() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  function clearState() {
    try {
      sessionStorage.removeItem(STORAGE_KEY);
    } catch (e) {
      /* ignore */
    }
  }

  function setTone(tone) {
    state.answers.tone = tone || 'discovery';
    if (root) root.setAttribute('data-tt-tone', state.answers.tone);
  }

  function progressPct() {
    var map = {
      intro: 0,
      intent: 12,
      pedido_motivo: 28,
      pedido_num: 40,
      resolve_track: 35,
      produto_motivo: 28,
      produto_pick: 40,
      produto_confirm: 36,
      escolher_quem: 28,
      escolher_idade: 40,
      escolher_objetivo: 48,
      troca_motivo: 28,
      troca_pedido: 40,
      resolve_troca: 35,
      pagamento_motivo: 28,
      entrega_motivo: 28,
      resolve_entrega: 35,
      outro_msg: 30,
      nome: 58,
      nome_confirm: 58,
      email: 68,
      email_confirm: 68,
      telefone: 78,
      telefone_confirm: 78,
      comentario: 88,
      review: 96,
    };
    return map[state.stepId] != null ? map[state.stepId] : 50;
  }

  function updateProgress() {
    var fill = $('[data-tt-progress-fill]');
    if (fill) fill.style.setProperty('--tt-contato-pct', progressPct() + '%');
    var progress = $('[data-tt-progress]');
    /* Barra desde as opções iniciais (intent); só some na intro */
    if (progress) progress.hidden = state.stepId === 'intro';
    var micro = $('[data-tt-micro]');
    if (!micro) return;
    var tips = {
      intent: '',
      pedido_motivo: 'Já estamos entendendo.',
      escolher_objetivo: 'Rapidinho.',
      comentario: 'Falta pouquinho.',
      review: '',
    };
    micro.textContent =
      state.stepId === 'intro' || state.stepId === 'intent' ? '' : tips[state.stepId] || '';
  }

  function syncNativeFields() {
    var nome = $('[data-tt-native="nome"]', formEl);
    var email = $('[data-tt-native="email"]', formEl);
    var tel = $('[data-tt-native="telefone"]', formEl);
    var msg = $('[data-tt-native="mensagem"]', formEl);
    if (nome) nome.value = state.answers.nome || '';
    if (email) email.value = state.answers.email || '';
    if (tel) tel.value = state.answers.skipPhone ? '' : state.answers.telefone || '';
    if (msg) msg.value = buildStructuredMessage();
  }

  function buildStructuredMessage() {
    var a = state.answers;
    var lines = [];
    lines.push('TIPO DE CONTATO');
    lines.push(a.categoriaLabel || a.categoria || '—');
    lines.push('');
    if (a.motivoLabel || a.motivo) {
      lines.push('MOTIVO');
      lines.push(a.motivoLabel || a.motivo);
      lines.push('');
    }
    if (a.pedido) {
      lines.push('PEDIDO');
      lines.push(a.pedido.indexOf('#') === 0 ? a.pedido : '#' + a.pedido);
      lines.push('');
    }
    if (a.produto) {
      lines.push('PRODUTO');
      lines.push(a.produto + (a.produtoHandle ? ' (' + a.produtoHandle + ')' : ''));
      lines.push('');
    }
    if (a.paraQuem) {
      lines.push('PARA QUEM');
      lines.push(a.paraQuem);
      lines.push('');
    }
    if (a.idade) {
      lines.push('IDADE');
      lines.push(a.idade);
      lines.push('');
    }
    if (a.objetivo) {
      lines.push('OBJETIVO / ESTÍMULO');
      lines.push(a.objetivo);
      lines.push('');
    }
    /* Nome/e-mail/tel já vão nos campos nativos Shopify — não repetir no Comentário */
    if (a.mensagem_adicional) {
      lines.push('MENSAGEM ADICIONAL');
      lines.push(a.mensagem_adicional);
    }
    return lines.join('\n').trim();
  }

  function validEmail(v) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(v || '').trim());
  }

  /* ─── Navegação ─── */
  function goTo(stepId, opts) {
    opts = opts || {};
    if (!opts.replace && state.stepId && state.stepId !== stepId) {
      state.history.push(state.stepId);
    }
    state.direction = opts.back ? 'back' : 'forward';
    state.stepId = stepId;
    saveState();
    render();
  }

  function goBack() {
    if (!state.history.length) return;
    var prev = state.history.pop();
    state.direction = 'back';
    state.stepId = prev;
    saveState();
    render();
  }

  function jumpTo(stepId) {
    /* Edição a partir do review: volta ao passo sem perder o restante */
    var idx = state.history.indexOf(stepId);
    if (idx >= 0) state.history = state.history.slice(0, idx);
    else state.history = state.history.filter(function (s) {
      return s !== 'review';
    });
    if (stepId === 'telefone' || stepId === 'telefone_confirm') {
      state.answers._phoneDone = false;
    }
    state.direction = 'back';
    state.stepId = stepId;
    saveState();
    render();
  }

  function afterSelect(btn, nextFn) {
    if (btn) {
      btn.classList.add('is-selected');
      var siblings =
        btn.parentNode &&
        btn.parentNode.querySelectorAll('.tt-contato__opt, .tt-contato__card');
      if (siblings) {
        siblings.forEach(function (el) {
          if (el !== btn) el.disabled = true;
        });
      }
    }
    var delay = reduceMotion() ? 0 : AUTO_MS;
    setTimeout(nextFn, delay);
  }

  /* ─── Render helpers ─── */
  function wrapScreen(html, opts) {
    opts = opts || {};
    var back =
      opts.showBack !== false && state.stepId !== 'intro'
        ? '<button type="button" class="tt-contato__back" data-tt-back>← Voltar</button>'
        : '';
    var dir = state.direction === 'back' ? 'is-enter-back' : 'is-enter-forward';
    var extra = opts.screenClass ? ' ' + opts.screenClass : '';
    return (
      '<div class="tt-contato__screen ' +
      dir +
      extra +
      '">' +
      back +
      html +
      '</div>'
    );
  }

  function renderChoice(cfg) {
    var cards = (cfg.options || [])
      .map(function (o, i) {
        var p = PASTELS[i % PASTELS.length];
        return (
          '<button type="button" class="tt-contato__card" data-tt-opt="' +
          escapeHtml(o.value) +
          '" data-label="' +
          escapeHtml(o.label) +
          '"' +
          (o.tone ? ' data-tone="' + escapeHtml(o.tone) + '"' : '') +
          ' style="--tt-card-bg:' +
          p.bg +
          ';--tt-card-accent:' +
          p.accent +
          '">' +
          cardIcon(o.icon) +
          '<span class="tt-contato__card-foot">' +
          '<span class="tt-contato__card-body">' +
          '<span class="tt-contato__card-title">' +
          escapeHtml(o.label) +
          '</span>' +
          (o.desc
            ? '<span class="tt-contato__card-desc">' + escapeHtml(o.desc) + '</span>'
            : '') +
          '</span>' +
          cardGo() +
          '</span></button>'
        );
      })
      .join('');

    return panelWrap(
      { kicker: cfg.kicker, title: cfg.title, lead: cfg.lead },
      '<div class="tt-contato__card-grid" role="list">' + cards + '</div>',
      'tt-contato__screen--choices'
    );
  }

  /* Passo inicial de opções — cards pastel + ícones 3D (ref. design) */
  function renderIntent() {
    var opts = [
      {
        value: 'pedido',
        label: 'Preciso de ajuda com um pedido',
        desc: 'Acompanhar, alterar ou tirar dúvidas.',
        tone: 'problem',
        bg: '#FFF1E4',
        accent: '#F4A243',
        iconKey: 'pedido',
      },
      {
        value: 'produto',
        label: 'Tenho uma dúvida sobre um brinquedo',
        desc: 'Idade, funcionamento, detalhes e mais.',
        tone: 'doubt',
        bg: '#E7F3FB',
        accent: '#5FA8D3',
        iconKey: 'produto',
      },
      {
        value: 'escolher',
        label: 'Quero ajuda para escolher',
        desc: 'Me ajudem a encontrar o brinquedo ideal.',
        tone: 'discovery',
        bg: '#E7F7EE',
        accent: '#7DA870',
        iconKey: 'escolher',
      },
      {
        value: 'troca',
        label: 'Quero trocar ou devolver um produto',
        desc: 'Trocas, devoluções e produtos com problema.',
        tone: 'problem',
        bg: '#FCE8F1',
        accent: '#F6A6D2',
        iconKey: 'troca',
      },
      {
        value: 'pagamento',
        label: 'Preciso de ajuda com pagamento',
        desc: 'PIX, cartão, boleto e cobranças.',
        tone: 'problem',
        bg: '#EEE8FA',
        accent: '#8B7EC8',
        iconKey: 'pagamento',
      },
      {
        value: 'entrega',
        label: 'Tenho uma dúvida sobre entrega',
        desc: 'Prazos, frete, rastreamento e endereço.',
        tone: 'doubt',
        bg: '#E4F6F7',
        accent: '#5BB8C4',
        iconKey: 'entrega',
      },
      {
        value: 'outro',
        label: 'É outro assunto',
        desc: 'Fale com a gente sobre outro tema.',
        tone: 'doubt',
        bg: '#FFF7E0',
        accent: '#F4A243',
        iconKey: 'outro',
      },
    ];

    var icons = (boot && boot.optionIcons) || {};
    var cards = opts
      .map(function (o) {
        var src = icons[o.iconKey] || '';
        return (
          '<button type="button" class="tt-contato__card" data-tt-opt="' +
          escapeHtml(o.value) +
          '" data-label="' +
          escapeHtml(o.label) +
          '" data-tone="' +
          escapeHtml(o.tone) +
          '" style="--tt-card-bg:' +
          o.bg +
          ';--tt-card-accent:' +
          o.accent +
          '">' +
          '<span class="tt-contato__card-icon" aria-hidden="true">' +
          (src
            ? '<img src="' + escapeHtml(src) + '" alt="" width="88" height="88" loading="lazy">'
            : '') +
          '</span>' +
          '<span class="tt-contato__card-foot">' +
          '<span class="tt-contato__card-body">' +
          '<span class="tt-contato__card-title">' +
          escapeHtml(o.label) +
          '</span>' +
          '<span class="tt-contato__card-desc">' +
          escapeHtml(o.desc) +
          '</span>' +
          '</span>' +
          cardGo() +
          '</span></button>'
        );
      })
      .join('');

    return panelWrap(
      {
        title: 'O que podemos fazer por você hoje?',
        lead: 'Escolha uma opção e a gente te leva pelo caminho certo.',
      },
      '<div class="tt-contato__card-grid tt-contato__card-grid--intent" role="list">' +
        cards +
        '</div>',
      'tt-contato__screen--intent'
    );
  }

  function renderInput(cfg) {
    return panelWrap(
      { kicker: cfg.kicker, title: cfg.title, lead: cfg.lead },
      '<div class="tt-contato__flow-stage">' +
        '<label class="tt-contato__label" for="tt-contato-field">' +
        escapeHtml(cfg.label || '') +
        '</label>' +
        (cfg.multiline
          ? '<textarea id="tt-contato-field" class="tt-contato__input tt-contato__textarea" rows="4" placeholder="' +
            escapeHtml(cfg.placeholder || '') +
            '">' +
            escapeHtml(cfg.value || '') +
            '</textarea>'
          : '<input id="tt-contato-field" class="tt-contato__input" type="' +
            escapeHtml(cfg.inputType || 'text') +
            '" autocomplete="' +
            escapeHtml(cfg.autocomplete || 'off') +
            '" placeholder="' +
            escapeHtml(cfg.placeholder || '') +
            '" value="' +
            escapeHtml(cfg.value || '') +
            '"' +
            (cfg.inputmode ? ' inputmode="' + escapeHtml(cfg.inputmode) + '"' : '') +
            '>') +
        '<p class="tt-contato__hint" data-tt-error hidden></p>' +
        (cfg.privacy ? '<p class="tt-contato__privacy">' + cfg.privacy + '</p>' : '') +
        '<div class="tt-contato__actions">' +
        '<button type="button" class="tt-contato__btn tt-contato__btn--primary" data-tt-continue>' +
        escapeHtml(cfg.cta || 'Continuar →') +
        '</button>' +
        (cfg.skip
          ? '<button type="button" class="tt-contato__link" data-tt-skip>' +
            escapeHtml(cfg.skip) +
            '</button>'
          : '') +
        '</div></div>'
    );
  }

  function renderConfirm(cfg) {
    return panelWrap(
      { title: cfg.title, lead: cfg.lead },
      '<div class="tt-contato__flow-stage">' +
        (cfg.valueHtml
          ? '<div class="tt-contato__confirm-value">' + cfg.valueHtml + '</div>'
          : '') +
        '<div class="tt-contato__actions">' +
        '<button type="button" class="tt-contato__btn tt-contato__btn--primary" data-tt-confirm-yes>' +
        escapeHtml(cfg.yes || 'Sim →') +
        '</button>' +
        '<button type="button" class="tt-contato__link" data-tt-confirm-no>' +
        escapeHtml(cfg.no || 'Usar outro') +
        '</button>' +
        (cfg.skip
          ? '<button type="button" class="tt-contato__link" data-tt-skip>' +
            escapeHtml(cfg.skip) +
            '</button>'
          : '') +
        '</div></div>'
    );
  }

  function renderResolve(cfg) {
    return panelWrap(
      { title: cfg.title, lead: cfg.lead },
      '<div class="tt-contato__flow-stage">' +
        '<div class="tt-contato__actions">' +
        (cfg.primaryHref
          ? '<a class="tt-contato__btn tt-contato__btn--primary" href="' +
            escapeHtml(cfg.primaryHref) +
            '">' +
            escapeHtml(cfg.primaryLabel) +
            '</a>'
          : '') +
        '<button type="button" class="tt-contato__link" data-tt-continue-help>' +
        escapeHtml(cfg.secondary || 'Ainda preciso de ajuda') +
        '</button>' +
        '</div></div>'
    );
  }

  /* ─── Steps ─── */
  function htmlForStep(id) {
    var a = state.answers;
    var c = boot.customer || {};

    switch (id) {
      case 'intro':
        return wrapScreen(
          '<div class="tt-contato__hero">' +
            '<div class="tt-contato__mascot">' +
            (boot.mascot
              ? '<img class="tt-contato__mascot-img" src="' +
                escapeHtml(boot.mascot) +
                '" alt="Oi! Estamos aqui para te ajudar!" width="420" height="324" loading="eager">'
              : '') +
            '</div>' +
            '<h2 class="tt-contato__title tt-contato__title--hero">' +
            'Como podemos<br><span class="tt-contato__title-accent">te ajudar?</span></h2>' +
            '<p class="tt-contato__lead tt-contato__lead--hero">Conte pra gente o que você precisa. São só algumas perguntinhas rápidas para levar sua mensagem ao lugar certo.</p>' +
            '<div class="tt-contato__actions tt-contato__actions--hero">' +
            '<button type="button" class="tt-contato__btn tt-contato__btn--hero" data-tt-start>Começar →</button>' +
            '</div></div>',
          { showBack: false, screenClass: 'tt-contato__screen--intro' }
        );

      case 'intent':
        return renderIntent();

      case 'pedido_motivo':
        return renderChoice({
          kicker: 'Entendi!',
          title: 'E o que aconteceu?',
          options: [
            { value: 'rastrear', label: 'Quero acompanhar meu pedido', icon: 'search' },
            { value: 'demora', label: 'Meu pedido está demorando', icon: 'truck' },
            { value: 'diferente', label: 'Recebi algo diferente', icon: 'package' },
            { value: 'problema', label: 'Meu produto chegou com um problema', icon: 'heart' },
            { value: 'alterar', label: 'Quero alterar alguma informação', icon: 'chat' },
            { value: 'outro_pedido', label: 'É outra coisa', icon: 'chat' },
          ],
        });

      case 'resolve_track':
        return renderResolve({
          title: 'Talvez a gente consiga resolver isso agora',
          lead: 'Você pode acompanhar seus pedidos na sua conta Titolin.',
          primaryHref: c.loggedIn ? boot.urls.account : boot.urls.accountLogin,
          primaryLabel: 'Acompanhar meu pedido →',
          secondary: 'Ainda preciso de ajuda',
        });

      case 'pedido_num':
        return renderInput({
          title: 'Qual é o número do pedido?',
          label: 'Número do pedido',
          placeholder: '#1234',
          value: a.pedido || '',
          autocomplete: 'off',
          inputmode: 'numeric',
          cta: 'Continuar →',
          skip: 'Não tenho agora',
        });

      case 'produto_motivo':
        return renderChoice({
          title: 'O que você gostaria de saber?',
          options: [
            { value: 'idade', label: 'Para qual idade é indicado?', icon: 'toy' },
            { value: 'estimula', label: 'O que esse brinquedo estimula?', icon: 'brain' },
            { value: 'funciona', label: 'Como funciona?', icon: 'puzzle' },
            { value: 'detalhes', label: 'Quero saber tamanho ou detalhes', icon: 'search' },
            { value: 'estoque', label: 'Quero saber sobre disponibilidade', icon: 'package' },
            { value: 'outra_duvida', label: 'Tenho outra dúvida', icon: 'chat' },
          ],
        });

      case 'produto_confirm':
        return panelWrap(
          { title: 'Estamos falando sobre este brinquedo?' },
          '<div class="tt-contato__flow-stage">' +
            '<div class="tt-contato__product-card">' +
            (a.produtoImage
              ? '<img src="' + escapeHtml(a.produtoImage) + '" alt="" width="64" height="64">'
              : '') +
            '<span>' +
            escapeHtml(a.produto) +
            '</span></div>' +
            '<div class="tt-contato__actions">' +
            '<button type="button" class="tt-contato__btn tt-contato__btn--primary" data-tt-confirm-yes>Sim →</button>' +
            '<button type="button" class="tt-contato__link" data-tt-confirm-no>Escolher outro</button>' +
            '</div></div>'
        );

      case 'produto_pick':
        return panelWrap(
          {
            title: 'Sobre qual brinquedo você quer falar?',
            lead: 'Busque pelo nome ou digite o que lembrar.',
          },
          '<div class="tt-contato__flow-stage">' +
            '<label class="tt-contato__label" for="tt-contato-field">Nome do brinquedo</label>' +
            '<input id="tt-contato-field" class="tt-contato__input" type="search" autocomplete="off" placeholder="Ex.: memória, blocos…" value="' +
            escapeHtml(a.produto || '') +
            '">' +
            '<ul class="tt-contato__suggest" data-tt-suggest hidden role="listbox"></ul>' +
            '<div class="tt-contato__actions">' +
            '<button type="button" class="tt-contato__btn tt-contato__btn--primary" data-tt-continue>Continuar →</button>' +
            '<button type="button" class="tt-contato__link" data-tt-skip>Não sei o nome</button>' +
            '</div></div>'
        );

      case 'escolher_quem':
        return renderChoice({
          kicker: 'Vamos encontrar algo legal juntos',
          title: 'Para quem é o brinquedo?',
          options: [
            { value: 'crianca', label: 'Para uma criança', icon: 'toy' },
            { value: 'presente', label: 'É para presente', icon: 'gift' },
          ],
        });

      case 'escolher_idade':
        return renderChoice({
          title: 'Qual é a idade?',
          options: [
            { value: '0–3 anos', label: '0–3 anos', icon: 'toy' },
            { value: '4–5 anos', label: '4–5 anos', icon: 'sparkles' },
            { value: '6–8 anos', label: '6–8 anos', icon: 'puzzle' },
            { value: '9–12 anos', label: '9–12 anos', icon: 'brain' },
            { value: '13+ anos', label: '13+ anos', icon: 'hand' },
          ],
        });

      case 'escolher_objetivo':
        return renderChoice({
          title: 'O que você gostaria de estimular?',
          options: [
            { value: 'Raciocínio', label: 'Raciocínio', icon: 'brain' },
            { value: 'Linguagem', label: 'Linguagem', icon: 'chat' },
            { value: 'Coordenação motora', label: 'Coordenação motora', icon: 'hand' },
            { value: 'Criatividade', label: 'Criatividade', icon: 'sparkles' },
            { value: 'Percepção e sentidos', label: 'Percepção e sentidos', icon: 'search' },
            { value: 'Autonomia', label: 'Autonomia', icon: 'heart' },
            { value: 'Ainda não sei', label: 'Ainda não sei', icon: 'chat' },
          ],
        });

      case 'troca_motivo':
        return renderChoice({
          kicker: 'Tudo bem. Vamos entender o que aconteceu.',
          title: 'O que você precisa?',
          options: [
            { value: 'trocar', label: 'Quero trocar um produto', icon: 'return' },
            { value: 'devolver', label: 'Quero devolver um produto', icon: 'package' },
            { value: 'errado', label: 'Recebi o produto errado', icon: 'package' },
            { value: 'defeito', label: 'O produto chegou com problema', icon: 'heart' },
            { value: 'outro_troca', label: 'Outro motivo', icon: 'chat' },
          ],
        });

      case 'resolve_troca':
        return renderResolve({
          title: 'Antes de seguir…',
          lead: boot.urls.refundPolicy
            ? 'Você pode consultar nossa política de trocas e devoluções. Se ainda precisar de ajuda, a gente continua juntos.'
            : 'Se ainda precisar de ajuda com a troca ou devolução, continue e conte o que aconteceu.',
          primaryHref: boot.urls.refundPolicy,
          primaryLabel: boot.urls.refundPolicy ? 'Ver política de trocas →' : null,
          secondary: 'Ainda preciso de ajuda',
        });

      case 'troca_pedido':
        return renderInput({
          title: 'Você tem o número do pedido?',
          label: 'Número do pedido',
          placeholder: '#1234',
          value: a.pedido || '',
          cta: 'Continuar →',
          skip: 'Não tenho agora',
        });

      case 'pagamento_motivo':
        return renderChoice({
          title: 'Qual é a sua dúvida sobre pagamento?',
          options: [
            { value: 'PIX', label: 'PIX', icon: 'sparkles' },
            { value: 'Cartão de crédito', label: 'Cartão de crédito', icon: 'card' },
            { value: 'Boleto', label: 'Boleto', icon: 'package' },
            { value: 'Pagamento não aprovado', label: 'Pagamento não aprovado', icon: 'shield' },
            { value: 'Cobrança', label: 'Cobrança', icon: 'card' },
            { value: 'Outro assunto', label: 'Outro assunto', icon: 'chat' },
          ],
        });

      case 'entrega_motivo':
        return renderChoice({
          title: 'O que você gostaria de saber?',
          options: [
            { value: 'Prazo de entrega', label: 'Prazo de entrega', icon: 'truck' },
            { value: 'Valor do frete', label: 'Valor do frete', icon: 'package' },
            { value: 'Onde está meu pedido?', label: 'Onde está meu pedido?', icon: 'search' },
            { value: 'Pedido atrasado', label: 'Pedido atrasado', icon: 'truck' },
            { value: 'Endereço de entrega', label: 'Endereço de entrega', icon: 'chat' },
            { value: 'Outra dúvida', label: 'Outra dúvida', icon: 'chat' },
          ],
        });

      case 'resolve_entrega':
        return renderResolve({
          title: 'Talvez a gente consiga resolver isso agora',
          lead: 'Na sua conta você consulta o status dos pedidos. Se preferir, continue e a gente te ajuda.',
          primaryHref: c.loggedIn ? boot.urls.account : boot.urls.accountLogin,
          primaryLabel: 'Ver meus pedidos →',
          secondary: 'Ainda preciso de ajuda',
        });

      case 'outro_msg':
        return renderInput({
          kicker: 'Sem problema',
          title: 'Conta pra gente sobre o que você quer falar.',
          label: 'Sua mensagem',
          placeholder: 'Escreva aqui…',
          value: a.mensagem_adicional || '',
          multiline: true,
          cta: 'Continuar →',
        });

      case 'nome_confirm':
        return renderConfirm({
          title: 'Você é ' + escapeHtml(c.firstName || c.name || '') + '?',
          yes: 'Sim, sou eu →',
          no: 'Usar outro nome',
        });

      case 'nome':
        return renderInput({
          title: 'Antes de continuar, como podemos te chamar?',
          label: 'Seu nome',
          placeholder: 'Seu nome',
          value: a.nome || '',
          autocomplete: 'name',
          cta: 'Continuar →',
        });

      case 'email_confirm':
        return renderConfirm({
          title: 'Podemos responder por este e-mail?',
          valueHtml: '<strong>' + escapeHtml(maskEmail(c.email)) + '</strong>',
          yes: 'Sim, pode usar ✓',
          no: 'Usar outro e-mail',
        });

      case 'email':
        return renderInput({
          title: 'E qual e-mail podemos usar para responder?',
          label: 'Seu e-mail',
          placeholder: 'seuemail@email.com',
          value: a.email || '',
          inputType: 'email',
          autocomplete: 'email',
          privacy: 'Usaremos este e-mail apenas para responder sobre esta solicitação.',
          cta: 'Continuar →',
        });

      case 'telefone_confirm':
        return renderConfirm({
          title: 'Podemos usar este número?',
          valueHtml: '<strong>' + escapeHtml(maskPhone(c.phone)) + '</strong>',
          yes: 'Sim',
          no: 'Usar outro',
          skip: 'Prefiro não usar telefone',
        });

      case 'telefone':
        return renderInput({
          title: 'Quer deixar um WhatsApp também?',
          lead: 'É opcional. Pode ajudar se precisarmos falar com você mais rápido.',
          label: 'WhatsApp',
          placeholder: '(00) 00000-0000',
          value: formatBrazilPhone(a.telefone || ''),
          inputType: 'tel',
          autocomplete: 'tel',
          inputmode: 'tel',
          privacy: 'Seus dados serão usados apenas para responder ao seu contato.',
          cta: 'Continuar →',
          skip: 'Prefiro não informar',
        });

      case 'comentario':
        return renderInput({
          title: 'Quer contar mais alguma coisa?',
          lead: 'Se tiver algum detalhe que possa nos ajudar, conta pra gente. Se não, pode seguir sem escrever nada.',
          label: 'Detalhes (opcional)',
          placeholder: 'Escreva aqui se quiser…',
          value: a.mensagem_adicional || '',
          multiline: true,
          cta: 'Continuar →',
          skip: 'Pular esta etapa',
        });

      case 'review':
        return renderReview();

      default:
        return wrapScreen('<p>Algo deu errado. <button type="button" data-tt-start class="tt-contato__link">Recomeçar</button></p>');
    }
  }

  function renderReview() {
    var a = state.answers;
    var rows = [];
    function row(label, value, step) {
      if (!value) return;
      rows.push(
        '<div class="tt-contato__review-row">' +
          '<div><span class="tt-contato__review-label">' +
          escapeHtml(label) +
          '</span>' +
          '<p class="tt-contato__review-value">' +
          escapeHtml(value) +
          '</p></div>' +
          '<button type="button" class="tt-contato__review-edit" data-tt-edit="' +
          escapeHtml(step) +
          '">Alterar</button></div>'
      );
    }
    row('Assunto', a.categoriaLabel, 'intent');
    row('Motivo', a.motivoLabel, a.categoria === 'pedido' ? 'pedido_motivo' : a.categoria === 'troca' ? 'troca_motivo' : a.categoria === 'produto' ? 'produto_motivo' : a.categoria === 'pagamento' ? 'pagamento_motivo' : a.categoria === 'entrega' ? 'entrega_motivo' : 'intent');
    row('Pedido', a.pedido, a.categoria === 'troca' ? 'troca_pedido' : 'pedido_num');
    row('Produto', a.produto, 'produto_pick');
    row('Para quem', a.paraQuem, 'escolher_quem');
    row('Idade', a.idade, 'escolher_idade');
    row('Estímulo', a.objetivo, 'escolher_objetivo');
    row('Nome', a.nome, 'nome');
    row('E-mail', a.email, 'email');
    if (a.telefone && !a.skipPhone) row('WhatsApp', a.telefone, 'telefone');
    if (a.mensagem_adicional && a.categoria !== 'outro') row('Detalhes', a.mensagem_adicional, 'comentario');
    if (a.mensagem_adicional && a.categoria === 'outro') row('Mensagem', a.mensagem_adicional, 'outro_msg');

    return panelWrap(
      { title: 'Só pra confirmar… está tudo certinho?' },
      '<div class="tt-contato__flow-stage tt-contato__flow-stage--wide">' +
        '<div class="tt-contato__review">' +
        rows.join('') +
        '</div>' +
        '<div class="tt-contato__actions">' +
        '<button type="button" class="tt-contato__btn tt-contato__btn--primary" data-tt-submit>Enviar mensagem</button>' +
        '</div></div>'
    );
  }

  /* ─── Routing helpers ─── */
  function nextIdentity() {
    var c = boot.customer || {};
    if (c.loggedIn && c.firstName && !state.answers.confirmedName && !state.answers.nome) {
      goTo('nome_confirm');
    } else if (!state.answers.nome) {
      goTo('nome');
    } else {
      nextAfterName();
    }
  }

  function nextAfterName() {
    var c = boot.customer || {};
    if (c.loggedIn && c.email && !state.answers.confirmedEmail && !state.answers.email) {
      goTo('email_confirm');
    } else if (!state.answers.email) {
      goTo('email');
    } else {
      nextAfterEmail();
    }
  }

  function nextAfterEmail() {
    var c = boot.customer || {};
    if (state.answers._phoneDone) {
      nextAfterPhone();
      return;
    }
    if (c.loggedIn && c.phone && !state.answers.confirmedPhone) {
      goTo('telefone_confirm');
      return;
    }
    goTo('telefone');
  }

  function nextAfterPhone() {
    state.answers._phoneDone = true;
    if (state.answers.categoria === 'outro') {
      goTo('review');
      return;
    }
    goTo('comentario');
  }

  function afterPedidoMotivo(value, label) {
    state.answers.motivo = value;
    state.answers.motivoLabel = label;
    if (value === 'rastrear') {
      goTo('resolve_track');
    } else if (value === 'demora' || value === 'diferente' || value === 'problema' || value === 'alterar' || value === 'outro_pedido') {
      if (value === 'demora' || value === 'diferente' || value === 'problema') setTone('problem');
      goTo('pedido_num');
    } else {
      goTo('pedido_num');
    }
  }

  function afterProdutoMotivo(value, label) {
    state.answers.motivo = value;
    state.answers.motivoLabel = label;
    if (boot.product && boot.product.title && !state.answers.produto) {
      state.answers.produto = boot.product.title;
      state.answers.produtoHandle = boot.product.handle || '';
      state.answers.produtoImage = boot.product.image || '';
      goTo('produto_confirm');
    } else if (state.answers.produto && state.answers.produtoHandle) {
      goTo('produto_confirm');
    } else {
      goTo('produto_pick');
    }
  }

  function afterEntregaMotivo(value, label) {
    state.answers.motivo = value;
    state.answers.motivoLabel = label;
    if (value === 'Onde está meu pedido?' || value === 'Pedido atrasado') {
      if (value === 'Pedido atrasado') setTone('problem');
      goTo('resolve_entrega');
    } else {
      nextIdentity();
    }
  }

  /* ─── Product search ─── */
  function searchProducts(q) {
    var list = $('[data-tt-suggest]');
    if (!list) return;
    if (!q || q.length < 2) {
      list.hidden = true;
      list.innerHTML = '';
      return;
    }
    var url =
      '/search/suggest.json?q=' +
      encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=5&resources[options][fields]=title,product_type,variants.title';

    fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        var products =
          (data && data.resources && data.resources.results && data.resources.results.products) ||
          (data && data.resources && data.resources.products) ||
          [];
        if (!products.length) {
          list.hidden = true;
          list.innerHTML = '';
          return;
        }
        list.innerHTML = products
          .map(function (p) {
            var img =
              (p.image && (p.image + (p.image.indexOf('?') >= 0 ? '&' : '?') + 'width=64')) ||
              (p.featured_image && p.featured_image.url) ||
              '';
            return (
              '<li role="option">' +
              '<button type="button" class="tt-contato__suggest-item" data-title="' +
              escapeHtml(p.title) +
              '" data-handle="' +
              escapeHtml(p.handle) +
              '" data-image="' +
              escapeHtml(img) +
              '">' +
              (img ? '<img src="' + escapeHtml(img) + '" alt="" width="40" height="40">' : '') +
              '<span>' +
              escapeHtml(p.title) +
              '</span></button></li>'
            );
          })
          .join('');
        list.hidden = false;
      })
      .catch(function () {
        list.hidden = true;
      });
  }

  /* ─── Event binding ─── */
  function bindScreen() {
    var start = $('[data-tt-start]');
    if (start) {
      start.addEventListener('click', function () {
        goTo('intent');
      });
    }

    var back = $('[data-tt-back]');
    if (back) back.addEventListener('click', goBack);

    root.querySelectorAll('[data-tt-opt]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var value = btn.getAttribute('data-tt-opt');
        var label = btn.getAttribute('data-label') || value;
        var tone = btn.getAttribute('data-tone');
        afterSelect(btn, function () {
          handleChoice(value, label, tone);
        });
      });
    });

    var cont = $('[data-tt-continue]');
    if (cont) {
      cont.addEventListener('click', function () {
        handleContinue();
      });
    }

    var skip = $('[data-tt-skip]');
    if (skip) {
      skip.addEventListener('click', function () {
        handleSkip();
      });
    }

    var yes = $('[data-tt-confirm-yes]');
    if (yes) {
      yes.addEventListener('click', function () {
        handleConfirmYes();
      });
    }

    var no = $('[data-tt-confirm-no]');
    if (no) {
      no.addEventListener('click', function () {
        handleConfirmNo();
      });
    }

    var help = $('[data-tt-continue-help]');
    if (help) {
      help.addEventListener('click', function () {
        handleContinueHelp();
      });
    }

    var submitBtn = $('[data-tt-submit]');
    if (submitBtn) {
      submitBtn.addEventListener('click', function () {
        handleSubmit(submitBtn);
      });
    }

    root.querySelectorAll('[data-tt-edit]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        jumpTo(btn.getAttribute('data-tt-edit'));
      });
    });

    var field = $('#tt-contato-field');
    if (field && state.stepId === 'telefone') {
      field.addEventListener('input', function () {
        var formatted = formatBrazilPhone(field.value);
        field.value = formatted;
        state.answers.telefone = formatted;
      });
      field.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          handleContinue();
        }
      });
    }

    if (field && state.stepId === 'produto_pick') {
      field.addEventListener('input', function () {
        clearTimeout(searchTimer);
        var q = field.value.trim();
        searchTimer = setTimeout(function () {
          searchProducts(q);
        }, 280);
      });
      field.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          handleContinue();
        }
      });
    }

    root.querySelectorAll('[data-tt-suggest] .tt-contato__suggest-item').forEach(function (item) {
      /* delegated via click on list */
    });

    var suggest = $('[data-tt-suggest]');
    if (suggest) {
      suggest.addEventListener('click', function (e) {
        var item = e.target.closest('.tt-contato__suggest-item');
        if (!item) return;
        state.answers.produto = item.getAttribute('data-title') || '';
        state.answers.produtoHandle = item.getAttribute('data-handle') || '';
        state.answers.produtoImage = item.getAttribute('data-image') || '';
        var inp = $('#tt-contato-field');
        if (inp) inp.value = state.answers.produto;
        suggest.hidden = true;
        saveState();
        afterSelect(item, function () {
          nextIdentity();
        });
      });
    }

    if (field && (state.stepId === 'nome' || state.stepId === 'email' || state.stepId === 'telefone' || state.stepId === 'pedido_num' || state.stepId === 'troca_pedido')) {
      field.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          handleContinue();
        }
      });
      setTimeout(function () {
        if (!reduceMotion()) field.focus();
      }, 50);
    }
  }

  function handleChoice(value, label, tone) {
    if (tone) setTone(tone);

    if (state.stepId === 'intent') {
      state.answers.categoria = value;
      state.answers.categoriaLabel = LABELS[value] || label;
      if (value === 'pedido') goTo('pedido_motivo');
      else if (value === 'produto') {
        setTone('doubt');
        goTo('produto_motivo');
      } else if (value === 'escolher') {
        setTone('discovery');
        goTo('escolher_quem');
      } else if (value === 'troca') {
        setTone('problem');
        goTo('troca_motivo');
      } else if (value === 'pagamento') {
        setTone('problem');
        goTo('pagamento_motivo');
      } else if (value === 'entrega') {
        setTone('doubt');
        goTo('entrega_motivo');
      } else if (value === 'outro') goTo('outro_msg');
      return;
    }

    if (state.stepId === 'pedido_motivo') {
      afterPedidoMotivo(value, label);
      return;
    }
    if (state.stepId === 'produto_motivo') {
      afterProdutoMotivo(value, label);
      return;
    }
    if (state.stepId === 'escolher_quem') {
      state.answers.paraQuem = label;
      goTo('escolher_idade');
      return;
    }
    if (state.stepId === 'escolher_idade') {
      state.answers.idade = label;
      goTo('escolher_objetivo');
      return;
    }
    if (state.stepId === 'escolher_objetivo') {
      state.answers.objetivo = label;
      nextIdentity();
      return;
    }
    if (state.stepId === 'troca_motivo') {
      state.answers.motivo = value;
      state.answers.motivoLabel = label;
      if (boot.urls.refundPolicy) goTo('resolve_troca');
      else goTo('troca_pedido');
      return;
    }
    if (state.stepId === 'pagamento_motivo') {
      state.answers.motivo = value;
      state.answers.motivoLabel = label;
      nextIdentity();
      return;
    }
    if (state.stepId === 'entrega_motivo') {
      afterEntregaMotivo(value, label);
    }
  }

  function handleContinue() {
    var field = $('#tt-contato-field');
    var val = field ? field.value.trim() : '';
    var err = $('[data-tt-error]');

    if (state.stepId === 'pedido_num' || state.stepId === 'troca_pedido') {
      if (val) state.answers.pedido = val.indexOf('#') === 0 ? val : '#' + val;
      nextIdentity();
      return;
    }
    if (state.stepId === 'produto_pick') {
      if (val) {
        state.answers.produto = val;
        nextIdentity();
      } else if (err) {
        err.hidden = false;
        err.textContent = 'Digite o nome do brinquedo ou escolha “Não sei o nome”.';
      }
      return;
    }
    if (state.stepId === 'outro_msg') {
      if (!val) {
        if (err) {
          err.hidden = false;
          err.textContent = 'Conta um pouquinho sobre o assunto para a gente te ajudar.';
        }
        return;
      }
      state.answers.mensagem_adicional = val;
      nextIdentity();
      return;
    }
    if (state.stepId === 'nome') {
      if (!val) {
        if (err) {
          err.hidden = false;
          err.textContent = 'Como podemos te chamar?';
        }
        return;
      }
      state.answers.nome = val;
      state.answers.confirmedName = true;
      nextAfterName();
      return;
    }
    if (state.stepId === 'email') {
      if (!validEmail(val)) {
        if (err) {
          err.hidden = false;
          err.textContent = val
            ? 'Parece que faltou alguma coisinha nesse e-mail. Dá uma conferida?'
            : 'Precisamos de um e-mail para conseguir te responder.';
        }
        return;
      }
      state.answers.email = val;
      state.answers.confirmedEmail = true;
      nextAfterEmail();
      return;
    }
    if (state.stepId === 'telefone') {
      state.answers.telefone = formatBrazilPhone(val);
      state.answers.skipPhone = !state.answers.telefone;
      state.answers._phoneDone = true;
      nextAfterPhone();
      return;
    }
    if (state.stepId === 'comentario') {
      state.answers.mensagem_adicional = val;
      goTo('review');
    }
  }

  function handleSkip() {
    if (state.stepId === 'pedido_num' || state.stepId === 'troca_pedido') {
      state.answers.pedido = '';
      nextIdentity();
      return;
    }
    if (state.stepId === 'produto_pick') {
      state.answers.produto = '';
      state.answers.produtoHandle = '';
      nextIdentity();
      return;
    }
    if (state.stepId === 'telefone' || state.stepId === 'telefone_confirm') {
      state.answers.skipPhone = true;
      state.answers.telefone = '';
      state.answers._phoneDone = true;
      nextAfterPhone();
      return;
    }
    if (state.stepId === 'comentario') {
      goTo('review');
    }
  }

  function handleConfirmYes() {
    var c = boot.customer || {};
    if (state.stepId === 'produto_confirm') {
      nextIdentity();
      return;
    }
    if (state.stepId === 'nome_confirm') {
      state.answers.nome = c.name || c.firstName || '';
      state.answers.confirmedName = true;
      nextAfterName();
      return;
    }
    if (state.stepId === 'email_confirm') {
      state.answers.email = c.email || '';
      state.answers.confirmedEmail = true;
      nextAfterEmail();
      return;
    }
    if (state.stepId === 'telefone_confirm') {
      state.answers.telefone = c.phone || '';
      state.answers.confirmedPhone = true;
      state.answers.skipPhone = false;
      state.answers._phoneDone = true;
      nextAfterPhone();
    }
  }

  function handleConfirmNo() {
    if (state.stepId === 'produto_confirm') {
      state.answers.produto = '';
      state.answers.produtoHandle = '';
      state.answers.produtoImage = '';
      goTo('produto_pick');
      return;
    }
    if (state.stepId === 'nome_confirm') {
      goTo('nome');
      return;
    }
    if (state.stepId === 'email_confirm') {
      goTo('email');
      return;
    }
    if (state.stepId === 'telefone_confirm') {
      goTo('telefone');
    }
  }

  function handleContinueHelp() {
    if (state.stepId === 'resolve_track') {
      goTo('pedido_num');
      return;
    }
    if (state.stepId === 'resolve_troca') {
      goTo('troca_pedido');
      return;
    }
    if (state.stepId === 'resolve_entrega') {
      goTo('pedido_num');
    }
  }

  function handleSubmit(btn) {
    if (submitting) return;
    if (!validEmail(state.answers.email) || !state.answers.nome) {
      goTo('review');
      return;
    }
    submitting = true;
    btn.disabled = true;
    btn.textContent = 'Enviando…';
    syncNativeFields();
    clearState();
    if (formEl && typeof formEl.requestSubmit === 'function') formEl.requestSubmit();
    else if (formEl) formEl.submit();
  }

  function render() {
    if (!stage) return;
    updateProgress();
    setTone(state.answers.tone);
    if (root) {
      root.classList.toggle('is-intro', state.stepId === 'intro');
      root.classList.toggle('is-intent', state.stepId === 'intent');
      /* Resto do fluxo: mesma casca visual que intent (pastel / shell branco) */
      root.classList.toggle(
        'is-flow',
        state.stepId !== 'intro' && state.stepId !== 'intent'
      );
    }
    var html = htmlForStep(state.stepId);
    stage.innerHTML = html;

    var screen = stage.querySelector('.tt-contato__screen');
    if (screen && !reduceMotion()) {
      requestAnimationFrame(function () {
        screen.classList.add('is-visible');
      });
    } else if (screen) {
      screen.classList.add('is-visible');
    }

    bindScreen();
    syncNativeFields();
  }

  function init() {
    root = document.querySelector('[data-tt-contato]');
    if (!root) return;
    if (root.querySelector('[data-tt-contato-success]')) {
      clearState();
      return;
    }

    formEl = root.querySelector('#ContactForm') || root.querySelector('form');
    stage = root.querySelector('[data-tt-stage]');
    var bootEl = root.querySelector('[data-tt-contato-boot]');
    if (!bootEl || !stage) return;

    try {
      boot = JSON.parse(bootEl.textContent);
    } catch (e) {
      boot = { customer: {}, urls: {}, icons: {}, product: null };
    }

    var saved = loadState();
    if (saved && saved.answers && saved.stepId && saved.stepId !== 'intro') {
      state.stepId = saved.stepId;
      state.history = saved.history || [];
      state.answers = Object.assign(state.answers, saved.answers);
    } else if (boot.product && boot.product.title) {
      state.answers.produto = boot.product.title;
      state.answers.produtoHandle = boot.product.handle || '';
      state.answers.produtoImage = boot.product.image || '';
    } else {
      /* Fallback se Liquid não resolveu ?produto= */
      try {
        var handle = new URLSearchParams(window.location.search).get('produto');
        if (handle) state.answers.produtoHandle = handle;
      } catch (e2) {
        /* ignore */
      }
    }

    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
